import React, { useState } from 'react'
import { InputContainer } from '../../../../../../common/components/form/form.module';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import PlansTemplateListContainer from './plan-templates/containers/plans-templates-list.container';
import EmailTemplateListContainer from './plan-templates/containers/email-templates-list.container';

export default function Plansmodal({ Close,
    handleItemSubmit, selectplan, campaignFrequency, onInnerBasicFormChange,
    tagNames, CampaignType,
    localSelectedCollection, handleSelectedTemplates }: any) {

    return (

        <div className="  w-full p-2 bg-white shadow-md rounded-md">
            <h1 className="text-xl font-bold mb-4 text-center">Add Plan</h1>

            <div className='grid md:grid-cols-3 lg:grid-cols-3 gap-3'>

                <InputContainer
                    label="Name"
                    labelField="Name"
                    onValueChange={(event: any, newValue: any) => {
                        onInnerBasicFormChange(event.target.value, 'Name');
                    }}
                    type="text"
                    value={selectplan?.Name}
                />

                <InputContainer
                    label="Campaign Frequency"
                    labelField="Text"
                    list={campaignFrequency}
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(event.target.value, 'FrequencyId');
                    }}
                    optionName='Choose Campaign Frequency '
                    type="select"
                    value={selectplan?.FrequencyId}
                    valueField="Value"
                />


                <InputContainer
                    isDateTimePicker
                    label="Start Date"
                    name="StartDateUtc"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(event.target.value, 'StartDateUtc');
                    }}
                    type="date"
                    value={selectplan?.StartDateUtc}
                />

                <InputContainer
                    isDateTimePicker
                    label="End Date"
                    name="EndDateUtc"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(event.target.value, 'EndDateUtc');
                    }}
                    type="date"
                    value={selectplan?.EndDateUtc}
                />
                <InputContainer
                    label="Enabled"
                    name="IsEnabled"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event,
                            'IsEnabled'
                        )
                    }}
                    type="checkbox"
                    value={selectplan?.IsEnabled}
                />

                <InputContainer
                    label="Campaign Type"
                    labelField="Text"
                    list={CampaignType.filter(item => item.Value !== 103)}
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(event.target.value, 'CampaignTypeId');
                    }}
                    optionName='Choose Campaign Type'
                    type="select"
                    value={selectplan?.CampaignTypeId}
                    valueField="Value"
                />


            </div>
            {selectplan?.CampaignTypeId === 101 && (
                <div className="shadow-card box-border px-4 my-4 border-2 rounded-lg">
                    <h5 className="font-semibold text-lg mb-3 border-b pb-2 flex items-center gap-2">
                        {/* Email Icon */}
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#000000" fill="none">
                            <path d="M2 6L8.91302 9.91697C11.4616 11.361 12.5384 11.361 15.087 9.91697L22 6" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"></path>
                            <path d="M2.01577 13.4756C2.08114 16.5412 2.11383 18.0739 3.24496 19.2094C4.37608 20.3448 5.95033 20.3843 9.09883 20.4634C11.0393 20.5122 12.9607 20.5122 14.9012 20.4634C18.0497 20.3843 19.6239 20.3448 20.7551 19.2094C21.8862 18.0739 21.9189 16.5412 21.9842 13.4756C22.0053 12.4899 22.0053 11.5101 21.9842 10.5244C21.9189 7.45886 21.8862 5.92609 20.7551 4.79066C19.6239 3.65523 18.0497 3.61568 14.9012 3.53657C12.9607 3.48781 11.0393 3.48781 9.09882 3.53656C5.95033 3.61566 4.37608 3.65521 3.24495 4.79065C2.11382 5.92608 2.08114 7.45885 2.01576 10.5244C1.99474 11.5101 1.99475 12.4899 2.01577 13.4756Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"></path>
                        </svg>
                        Email Details
                    </h5>
                    <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-3">
                        <InputContainer
                            label="Reply To"
                            type="multiselectText"
                            value={selectplan?.ReplyToEmailInclusions}
                            onValueChange={(newValue: any) => {
                                const valueData = newValue.map((option: any) => option?.id || "");
                                onInnerBasicFormChange(valueData, "ReplyToEmailInclusions");
                            }}
                        />
                        <InputContainer
                            label="Recipient"
                            labelField="displayText"
                            list={tagNames}
                            type="multiselect"
                            valueField="Id"
                            value={selectplan?.RecipientTagIdInclusions}
                            onValueChange={(newValue: any) => {
                                const categoryData = newValue.map((option: any) => option?.value || "");
                                onInnerBasicFormChange(categoryData, "RecipientTagIdInclusions");
                            }}
                        />
                        <InputContainer
                            label="CC"
                            labelField="displayText"
                            list={tagNames}
                            type="multiselect"
                            valueField="Id"
                            value={selectplan?.CCTagIdInclusions}
                            onValueChange={(newValue: any) => {
                                const categoryData = newValue.map((option: any) => option?.value || "");
                                onInnerBasicFormChange(categoryData, "CCTagIdInclusions");
                            }}
                        />
                        <InputContainer
                            label="BCC"
                            labelField="displayText"
                            list={tagNames}
                            type="multiselect"
                            valueField="Id"
                            value={selectplan?.BCCTagIdInclusions}
                            onValueChange={(newValue: any) => {
                                const categoryData = newValue.map((option: any) => option?.value || "");
                                onInnerBasicFormChange(categoryData, "BCCTagIdInclusions");
                            }}
                        />
                    </div>
                    {
                        <AccordionContainer
                            child={
                                <EmailTemplateListContainer
                                    EmailPlanId={selectplan.EmailPlanId}
                                    selectedCollection={localSelectedCollection}
                                    // closeModal={closeModal} 
                                    // handleSubmitData={handleSubmitData}
                                    handleSelectedTemplates={handleSelectedTemplates}

                                />

                            }
                            expandedPanel="Templates"
                            headerTitle="Select a template"
                        />
                    }
                </div>

            )}

            {/* SMS Section */}
            {selectplan?.CampaignTypeId === 102 && (
                <div className="shadow-card box-border px-4 my-4 border-2 rounded-lg">
                    <h5 className="font-semibold text-lg mb-3 border-b pb-2 flex items-center gap-2">
                        {/* SMS Icon */}
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#000000" fill="none">
                            <path d="M18.6436 4C18.4955 3.61742 18.2933 3.29898 18.0175 3.02513C16.9851 2 15.3234 2 12 2C8.67661 2 7.01491 2 5.98247 3.02513C5.70666 3.29898 5.50453 3.61742 5.3564 4M5 18C5.08715 19.4194 5.32629 20.3233 5.98247 20.9749C7.01491 22 8.67661 22 12 22C15.3234 22 16.9851 22 18.0175 20.9749C18.6737 20.3233 18.9128 19.4194 19 18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"></path>
                            <path d="M6 10L8 12M8 10L6 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                            <path d="M11 10L13 12M13 10L11 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                            <path d="M16 10L18 12M18 10L16 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                            <path d="M17 7H7C5.11438 7 4.17157 7 3.58579 7.58579C3 8.17157 3 9.11438 3 11C3 12.8856 3 13.8284 3.58579 14.4142C4.17157 15 5.11438 15 7 15H17C18.8856 15 19.8284 15 20.4142 14.4142C21 13.8284 21 12.8856 21 11C21 9.11438 21 8.17157 20.4142 7.58579C19.8284 7 18.8856 7 17 7Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                            <path d="M12 19V19.01" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                        </svg>
                        SMS Details
                    </h5>
                    <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-3">
                        <InputContainer
                            label="Reply To"
                            type="text"
                            value={selectplan?.ReplyToSMS}
                            onValueChange={(event: any) => {
                                onInnerBasicFormChange(event.target.value, "ReplyToSMS");
                            }}
                        />
                    </div>
                    {
                        <AccordionContainer
                            child={
                                <PlansTemplateListContainer
                                    //   selectedDomain={selectedDomain}
                                    selectedCollection={localSelectedCollection}
                                    // closeModal={closeModal} 
                                    // handleSubmitData={handleSubmitData}
                                    handleSelectedTemplates={handleSelectedTemplates}

                                />

                            }
                            expandedPanel="Templates"
                            headerTitle="Select a template"
                        />
                    }
                </div>
            )}

            <div className="flex justify-end mt-6">
                <button
                    onClick={Close}
                    type="button"
                    className="m-2 bg-blue-900 text-white rounded font-medium px-4 py-3"
                >
                    Close
                </button>
                <button
                    className="m-2 bg-blue-900 text-white rounded font-medium px-4 py-3"
                    onClick={handleItemSubmit}
                    type="submit"
                >
                    Save
                </button>
            </div>

        </div>



    )
}